import { render } from "./OurBlog.vue?vue&type=template&id=5727a33e&scoped=true"
import script from "./OurBlog.vue?vue&type=script&lang=js"
export * from "./OurBlog.vue?vue&type=script&lang=js"

import "./OurBlog.vue?vue&type=style&index=0&id=5727a33e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5727a33e"]])

export default __exports__